module.exports = __webpack_public_path__ + "static/media/6_nature.45cc2a07.jpg";